import { createI18n } from 'vue-i18n'
import en from '@/locales/en.json'
import es from '@/locales/es.json'
import ptBR from '@/locales/pt-BR.json'

export const SUPPORTED_LOCALES = ['en', 'es', 'pt-BR']

export function detectLocale(queryLang) {
  if (queryLang && SUPPORTED_LOCALES.includes(queryLang)) {
    localStorage.setItem('lang', queryLang)
    return queryLang
  }
  const saved = localStorage.getItem('lang')
  if (saved && SUPPORTED_LOCALES.includes(saved)) return saved
  const browser = navigator.language?.slice(0, 5)
  if (browser === 'pt-BR' || browser?.startsWith('pt')) return 'pt-BR'
  if (browser?.startsWith('es')) return 'es'
  return 'en'
}

export const i18n = createI18n({
  legacy: false,
  locale: 'en',
  fallbackLocale: 'en',
  messages: { en, es, 'pt-BR': ptBR },
})
